import React from 'react';
import styles from './label.module.scss';

const Label = props => (
  <div className={`col-12 px-0 mx-0 ${styles.label}`}>
    {props.children}
  </div>
);

export default Label;
